import DeliveryDateLabel from 'Components/DeliveryDateLabel/DeliveryDateLabel'
import { t } from 'i18next'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { FormatedDate } from 'Utils/functions'

export const DocumentAddressDetails = ({
  showHomeDeliveryAddress,
  webOdvDetails,
  promisedDate,
}) => {
  const { sellOrderPostData } = useSelector(state => state.sellOrder)
  const useSelectorProducts = useSelector(state => state.cotizacion.QuoteHeader)
  const customerSavedLocations = useSelector(
    state => state.sellOrder.customerInfoObject
  )

  const isWebDocument =
    sellOrderPostData?.Data?.SalesDocumentInfo?.Origin === 'AB'
  const addressData = customerSavedLocations?.AddressList
  const busAddressId = webOdvDetails?.AddressId?.toLowerCase()

  const selectedAddressData = useMemo(() => {
    return addressData?.find(
      address => address?.AddressInfo?.AddressId?.toLowerCase() === busAddressId
    )?.AddressInfo
  }, [addressData, busAddressId])

  const phoneNumber =
    useSelectorProducts?.Address_PhoneNumber ||
    sellOrderPostData?.Data?.SalesDocumentInfo?.Address_PhoneAddress
  const nameMerchandise =
    sellOrderPostData?.Data?.SalesDocumentInfo?.FullNameWithdrawVA ||
    sellOrderPostData?.Data?.SalesDocumentInfo?.FullNameWithdrawWeb
  const phoneMerchandise =
    sellOrderPostData?.Data?.SalesDocumentInfo?.PhoneNumberVA ||
    sellOrderPostData?.Data?.SalesDocumentInfo?.PhoneNumberWithdrawWeb
  const commentsMerchandise =
    sellOrderPostData?.Data?.SalesDocumentInfo?.AdditionalNoteVA ||
    sellOrderPostData?.Data?.SalesDocumentInfo?.AdditionalNoteWeb

  const isInfoMerchandiseRetirement =
    nameMerchandise || phoneMerchandise || commentsMerchandise

  const formattedDate = webOdvDetails?.DeliveryDate

  const fulfillmentPlan =
    (useSelectorProducts.Lines || []).filter(
      item => item.FulfillmentPlanDescription
    )?.[0]?.FulfillmentPlanDescription ?? null

  return (
    <div
      className="sell-order-info-gen-retiro"
      data-testid="container-delivery-info">
      {showHomeDeliveryAddress && (
        <>
          <p className="sell-order-info-gen-text">
            {t('SELL_ORDER_T.DELIVERY_HOME')}
          </p>
          <p className="sell-order-info-gen-text">
            {t('SELL_ORDER_T.ADDRESS_LABEL', {
              address:
                useSelectorProducts?.QuoteAddressStreet ||
                useSelectorProducts?.QuoteAddressDetail,
            })}
          </p>
          {useSelectorProducts?.QuoteDistrictName && (
            <p className="sell-order-info-gen-text">
              {`${useSelectorProducts.CustomerAddress}`}
            </p>
          )}
          <p className="sell-order-info-gen-text">{`Alias: ${
            isWebDocument
              ? selectedAddressData?.Name ||
                useSelectorProducts?.Address_AddressName ||
                useSelectorProducts?.QuoteAddressDetail
              : useSelectorProducts?.Address_AddressName ||
                useSelectorProducts?.QuoteAddressDetail
          }`}</p>
          {phoneNumber && (
            <p className="sell-order-info-gen-text">
              {t('DISPATCH_ORDER_T.PHONE_ADDRESS', {
                phone: phoneNumber,
              })}
            </p>
          )}
          {isInfoMerchandiseRetirement ? (
            <>
              <p className="sell-order-info-gen-text">
                {t('SELL_ORDER_T.MERCHANDISE.RETIREMENT', {
                  retirement:
                    nameMerchandise || t('SELL_ORDER_T.NO_INFO_LABEL'),
                })}
              </p>
              <p className="sell-order-info-gen-text">
                {t('SELL_ORDER_T.MERCHANDISE.PHONE', {
                  phone: phoneMerchandise || t('SELL_ORDER_T.NO_INFO_LABEL'),
                })}
              </p>
              <p className="sell-order-info-gen-text">
                {t('SELL_ORDER_T.MERCHANDISE.NOTE', {
                  note: commentsMerchandise || t('SELL_ORDER_T.NO_INFO_LABEL'),
                })}
              </p>
            </>
          ) : null}
          {isWebDocument && formattedDate && (
            <p className="sell-order-info-gen-text">
              Fecha promesa: {FormatedDate(formattedDate.slice(0, 10))}
            </p>
          )}
          <DeliveryDateLabel date={promisedDate} variant="delivery" />
        </>
      )}
      {!showHomeDeliveryAddress && (
        <>
          <p className="sell-order-info-gen-text">
            {t('SELL_ORDER_T.BRANCH_RECOLECTION_LABEL')}
          </p>
          <p className="sell-order-info-gen-text">
            {t('SELL_ORDER_T.ADDRESS_LABEL', {
              address: useSelectorProducts.WarehouseAddress,
            })}
          </p>
          <p className="sell-order-info-gen-text">
            {useSelectorProducts.WarehouseDescription}
          </p>
          {isInfoMerchandiseRetirement ? (
            <>
              <p className="sell-order-info-gen-text">
                {t('SELL_ORDER_T.MERCHANDISE.RETIREMENT', {
                  retirement:
                    nameMerchandise || t('SELL_ORDER_T.NO_INFO_LABEL'),
                })}
              </p>
              <p className="sell-order-info-gen-text">
                {t('SELL_ORDER_T.MERCHANDISE.PHONE', {
                  phone: phoneMerchandise || t('SELL_ORDER_T.NO_INFO_LABEL'),
                })}
              </p>
              <p className="sell-order-info-gen-text">
                {t('SELL_ORDER_T.MERCHANDISE.NOTE', {
                  note: commentsMerchandise || t('SELL_ORDER_T.NO_INFO_LABEL'),
                })}
              </p>
            </>
          ) : null}
          {isWebDocument && formattedDate && (
            <p className="sell-order-info-gen-text">
              Fecha promesa: {FormatedDate(formattedDate.slice(0, 10))}
            </p>
          )}
          <DeliveryDateLabel date={promisedDate} variant="pickup" />
        </>
      )}
      {fulfillmentPlan && <p>Plan de entrega: {fulfillmentPlan}</p>}
    </div>
  )
}
